import React from "react";
import "./landing.css";

export default function Landing() {
  return (
    <div className="mmu-landing-container">
      
      {/* Hero Section */}
      <section className="mmu-hero-section">
        <h1>Unlock Your Market Potential</h1>
        <p>AI-driven insights, trusted strategies, and smarter decisions.</p>
        <button className="mmu-hero-btn">Start Your Journey</button>
      </section>

      {/* Features Section */}
      <section className="mmu-features-section">
        <h2>Why Customers Trust MarketMind4U?</h2>
        <div className="mmu-features-grid">
          <div className="mmu-feature-card">
            <div className="mmu-icon">💡</div>
            <h3>Intelligent Insights</h3>
            <p>Our AI monitors the market and gives you actionable insights instantly.</p>
          </div>
          <div className="mmu-feature-card">
            <div className="mmu-icon">🔍</div>
            <h3>Real-Time Analytics</h3>
            <p>Track trends and performance to make smarter investment decisions.</p>
          </div>
          <div className="mmu-feature-card">
            <div className="mmu-icon">🔒</div>
            <h3>Safe & Secure</h3>
            <p>Your data and decisions are always private and secure with us.</p>
          </div>
          <div className="mmu-feature-card">
            <div className="mmu-icon">⚡</div>
            <h3>Fast Execution</h3>
            <p>Act quickly on market opportunities without any delay.</p>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="mmu-testimonials-section">
        <h2>What Our Users Say</h2>
        <div className="mmu-testimonials-grid">
          <div className="mmu-testimonial-card">
            <p>"MarketMind4U ne meri trading aur planning dono improve kar diya!"</p>
            <h4>- Ravi Kumar</h4>
          </div>
          <div className="mmu-testimonial-card">
            <p>"Insights bahut hi accurate hain, ab decision lena easy ho gaya."</p>
            <h4>- Priya Singh</h4>
          </div>
          <div className="mmu-testimonial-card">
            <p>"Fast aur secure platform, main daily use karta hu!"</p>
            <h4>- Amit Sharma</h4>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="mmu-cta-section">
        <h2>Ready to Elevate Your Market Game?</h2>
        <button className="mmu-hero-btn">Get Started Now</button>
      </section>

    </div>
  );
}
